<template>
  <b-container>
    <tool-header
      tool-name="Mobile Util Pages Viewer"
      tool-icon-text="Mobile util pages that can be passed around for internal use" />
    <b-row
      align-v="center"
      class="my-2">
      <b-col cols="5">
        <b-input
          v-model="filterText"
          type="text"
          placeholder="Search in this folder..." />
      </b-col>
    </b-row>
    <b-row align-v="center">
      <b-col cols="8">
        <div class="mt-2 mb-3 breadcrumbs">
          <b-link
            class="mx-2"
            @click.stop="$router.push({query: { path: ''}})">
            <em class="fas fa-home" />
          </b-link>
          <span
            v-for="element in pathItems"
            :key="element.href">
            <span class="mx-2">/</span>
            <b-link
              v-if="!element.active"
              @click.stop="$router.push({query: { path: `${element.href}`}})">
              {{ element.text }}
            </b-link>
            <span v-else>
              {{ element.text }}
            </span>
          </span>
        </div>
      </b-col>  
    </b-row>
    <files-table
      ref="filesTable"
      :files="files"
      :filter="filterText"
      :path="path"
      :loading="loading"
      @update-path="(idx, path) => $router.push({ query: { path: `${path}` }}).catch(err => console.error(err))"
      @preview="onPreviewAsset"
      @download="onDownloadAsset"
      @copy-url="copyAssetUrl"
      @asset-selected="onAssetSelected" />
    <b-modal
      ref="assetPreviewModal"
      title="Preview"
      size="lg"
      ok-only
      ok-variant="secondary">
      <b-container
        v-if="assetToPreview"
        class="mb-2">
        <div>
          <strong>File Name</strong>: {{ assetToPreview.name }}
        </div>
        <div>
          <strong>Size</strong>: {{ assetToPreview.bytes | formatSize }}
        </div>
        <div>
          <strong>Last Modified</strong>: {{ assetToPreview.lastModified | formatDateTime }}
        </div>
      </b-container>
      <b-img
        v-if="assetToPreview"
        :src="assetToPreview.url"
        fluid
        style="display: block; margin: auto" />
    </b-modal>
  </b-container>
</template>

<script>
import ToolHeader from '../components/ToolHeader.vue'
import common from '@/services/common'
import {MobileUtilPages} from '@/services/api'
import FilesTable from '@/components/FilesTable'

export default {
  name: "MobileUtilPages",
  components: {
    ToolHeader,
    FilesTable,
  },
  data(){
    return {
      filterText: '',
      selectedAssets: [],
      files: [],
      pathItems: [],
      path: '',
      loading: true,
      assetToPreview: null,
    }
  },
  watch: {
    "$route.query.path"(newVal) {
      this.updatePath(newVal)
    },
  },
  created(){
    this.refreshAssets()
  },
  methods: {
    async getFiles(path) {
      return await MobileUtilPages.getFiles(path)
    },
    getPathItems(path) {
      if (!path || path === '/') {
        return []
      }

      // Build the items to be used in the breadcrumb path
      let href = ''
      const items = path.split('/').map((element) => {
        href += href.length > 0 ? `/${element}` : `${element}`
        return {
          text: element,
          href: href,
        }
      })

      // Mark the last element in the path as active
      if (items && items.length > 0) {
        items[items.length - 1].active = true
      }

      return items
    },
    async refreshAssets() {
      this.loading = true
      try {
        this.files = await this.getFiles(this.path)
        this.pathItems = this.getPathItems(this.path)
        this.selectedAssets = []
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(`Unable to retrieve mobile-util files`, error)
        throw error
      }
    },
    onAssetSelected(assets) {
      this.selectedAssets = assets
    },
    onAssetSelect(url) {
      if (url) {
        this.refreshAssets()
      } else {
        console.warn('Ignoring invalid asset selection')
      }
    },
    onDownloadMultipleAssets() {
      // Only files are supported for download at the moment so folders are filtered out
      this.selectedAssets
        .filter(asset => asset.contentType !== 'folder')
        .forEach(item => {
          common.downloadFile(item.url, item.name)
        })
    },
    onDownloadAsset(assetUrl, asset) {
      return common.downloadFile(`/api/client-content/proxy/v1?target=${assetUrl}`, asset)
    },
    onPreviewAsset(asset) {
      this.assetToPreview = asset
      console.log(`Previewing asset ${JSON.stringify(asset)}`)
      this.$refs.assetPreviewModal.show()
    },
    async copyAssetUrl(url) {
        await this.$copyText(url)
        this.$alert.success('Link copied!')
    },
    updatePath(path) {
      console.log(`Updating path to ${path}`)
      this.loading = true
      this.path = path
      this.pathItems = this.getPathItems(path)
      this.selectedAssets = []
      this.files = []
      this.refreshAssets()
    },
  },
}
</script>

<style scoped>
  .download-icon {
    background-image: url(../../public/img/icons/download-icon.svg);
    background-size: cover;
    display: inline-block;
    height: 15px;
    width: 15px;
    vertical-align: text-bottom;
  }
</style>